import { loc } from "../../../core/utils"
import { withPackContext } from "../../hoc/withPackContext"
import { withTunnelDataContext } from "../../hoc/withTunnelDataContext"
import clsx from "clsx"
import React, { useEffect, useMemo } from "react"

const DurationSelect = ({ changePackContext, tunnelData, packContext }) => {
  const { packs, duration } = packContext
  const durations = useMemo(() => extractDurations(packs), [packs])

  useEffect(() => {
    if (!duration) {
      changePackContext({
        duration: durations.includes(tunnelData.defaultPackServiceDuration)
          ? tunnelData.defaultPackServiceDuration
          : durations[0]
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [durations])

  return (
    durations?.length > 1 && (
      <>
        <div className="d-flex justify-content-center margin-bottom-40">{loc(tunnelData.MentionForDuration)}</div>
        <div className="d-flex justify-content-center duration-div">
          {durations.map((option) => (
            <button
              className={clsx("duration-button", option === duration && "selected")}
              onClick={() => changePackContext({ duration: option })}
              key={option}
            >
              {option + " " + loc("months_uppercase")}
            </button>
          ))}
        </div>
      </>
    )
  )
}

const extractDurations = (packs) => {
  return packs
    ? packs.reduce((durations, pack) => {
        const duration = pack?.rentDTO?.duration
        if (!durations.includes(duration)) {
          durations.push(duration)
        }
        return durations.sort()
      }, [])
    : []
}

export default withTunnelDataContext(withPackContext(DurationSelect))
